// extracted by mini-css-extract-plugin
export default {"twoColumnSection":"styles_twoColumnSection__6TsrB","image":"styles_image__XsJl5","columnContent":"styles_columnContent__LPdCE","link":"styles_link__aRvHa"};